import template from './bagouts.html';
import controller from './bagouts.controller';
import './bagouts.scss';

let printComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default printComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/bagouts/print/bagouts.component.js